<template>
  <BottomSheet :visible="visible" :height="heightBottomSheet" :enableDrag="false" @close="$emit('close', false)">
    <template #header>
      <div class="flex pt-8 pb-4 justify-between items-center px-16">
        <div :style="isDesktop ? { width: '52px' } : { width: '36px' }">
          <button class="flex items-center" v-show="currentStep !== arrayStepEnquiry[firstIndex]" @click.prevent="() => handleBack()">
            <img :src="`${ASSETS_CDN}/images/enquiryB2C/icon-back.png`" alt="Back" />
            <span v-if="isDesktop" class="fs-14 lh-20 fw-600">Back</span>
          </button>
        </div>
        <div class="flex items-center">
          <img :src="`${ASSETS_CDN}/images/enquiryB2C/icon-flash.png`" alt="Icon" />
          <span class="fs-14 lh-20 fw-600 brand-950 pl-5">Plan your trip in 5 simple steps</span>
        </div>
        <div class="flex items-center px-8 py-8">
          <button @click.prevent="$emit('close')">
            <img :src="`${ASSETS_CDN}/images/enquiryB2C/icon-close.png`" alt="Close" />
          </button>
        </div>
      </div>
    </template>
    <template #content>
      <MultiStepsForm :popupHeight="popupHeight" :isUIPopup="true" :stepBack="stepBack" />
    </template>
  </BottomSheet>
</template>
<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { useRoute } from "vue-router"
import MultiStepsForm from '~/components/pages/Enquiry/MultiStepsForm/Steps/MultiStepsForm.vue'
import BottomSheet from '~/components/ui/bottom-sheet/BottomSheet.vue'
import { DESKTOP } from '~/constant/common'
import { EnquiryStepEnum } from '~/enum/enquiry'
import { assetCDN } from '~/helper'
import { useEnquiryCaptureStore } from '~/store/pinia/enquiryCapture'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})
defineEmits(['close'])
const heightBottomSheet = '625px' //vh
const firstIndex = 0
const popupHeight = ref(0)
const stepBack = ref<EnquiryStepEnum | undefined>(undefined)
const enquiryCaptureStore = useEnquiryCaptureStore()
const route = useRoute()
const ASSETS_CDN = assetCDN()
const generalStore = useGeneralInfoStore()

const windowWidth = computed(() => generalStore.generalData.windowWidth)
const isDesktop = computed(() => windowWidth.value > DESKTOP)
const arrayStepEnquiry = computed(() => enquiryCaptureStore.arrayStep)
const stepsData = computed(() => enquiryCaptureStore.stepsData)
const currentStep = computed(() => {
  if (stepsData.value && stepsData.value[route.path.toString()]) return stepsData.value[route.path.toString()].step
  return arrayStepEnquiry.value[firstIndex]
})

const handleBack = () => {
  const idx = arrayStepEnquiry.value.findIndex((step: any) => step === currentStep.value)
  stepBack.value = arrayStepEnquiry.value[idx - 1]
}
watch(
  () => currentStep.value,
  () => {
    stepBack.value = undefined
  },
)
onMounted(() => {
  popupHeight.value = 625
})
</script>
